import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-pivot-drag-icon',
  templateUrl: 'pivot-drag-icon.component.html'
})
export class PivotDragIconComponent {
  constructor() {}
}
